export default {
    ru: [
        {
            title: 'О выставке',
            items: [
                {
                    title: 'Общая информация',
                    link: 'pages/about',
                },
                {
                    title: 'Брошюра',
                    link: '/files/rubae_presentation_2021.pdf',
                },
                {
                    title: 'План выставки',
                    //link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition.pdf',
                    // link: 'pages/updating',
                },
                // {
                //     title: 'Статическая площадка',
                //     link: 'pages/static',
                // },
                {
                    title: 'Список участников',
                    link: 'pages/exhibitors-list',
                },
                // {
                //     title: 'Деловая программа',
                //     link: 'pages/schedule',
                // },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                // {
                //     title: 'Время работы',
                //     link: 'pages/opening-hours',
                // },
            ],
        },
        {
            title: 'Участникам',
            items: [
                // {
                //     title: 'Виды участия',
                //     link: 'pages/exhibit-application',
                // },
                {
                    title: 'План экспозиции',
                    // link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition.pdf',
                    // link: 'pages/updating',
                },
                {
                    title: 'Личный кабинет',
                    link: 'https://lk.rubae.ru',
                },
                //{
                //     title: 'Заявка участника',
                //     link: '/files/exhibit-application-ru.pdf',
                //},
                {
                    title: 'First time exhibitor application',
                    link: '/files/First Time 2021 rus.pdf',
                },
                // {
                //     title: 'Заявка участника на статику',
                //     link: '/files/static-application-en.pdf',
                // },
                {
                    title: 'Руководство участника',
                    link: '/files/exhibitor-manual-ru.pdf',
                },
                {
                    title: 'Дополнительные услуги',
                    link: '/files/Additional equipment rus 2021.pdf',
                },
                {
                    title: 'Спонсорство и реклама',
                    link: '/files/RUBAE_2021_rus.pdf',
                },
                {
                    title: 'Broker Project',
                    link: 'pages/broker-project',
                },
                {
                    title: 'Деловая программа',
                    link: 'pages/conference-program',
                },
                {
                    title: 'Газета Show Daily',
                    link: '/files/ShowDaily.pdf',
                },
                {
                    title: 'Визовая поддержка',
                    link: 'pages/visa-support',
                },
                // {
                //     title: 'Услуги по уборке воздушных судов',
                //     link: 'pages/aircraft-cleaning',
                // },
                {
                    title: 'Трансфер партнер',
                    link: 'pages/transfer-partner',
                },
                {
                    title: 'Программа мероприятия',
                    link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                },
                {
                    title: 'Размещение в отеле',
                    link: 'pages/hotel-partner',
                },
                // {
                //     title: 'Размещение в отеле',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        {
            title: 'Посетителям',
            items: [
                // {
                //     title: 'Регистрация',
                //     link: 'pages/registration/',
                // },
                // {
                //     title: 'Купить билет',
                //     //link: 'pages/ticket',
                //     //link: 'pages/registration/',
                //     link: 'https://rubae21.ruwidgets.ru/',
                // },
                {
                    title: 'Время работы',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Как добраться',
                    link: 'pages/location',
                },
                // {
                //     title: 'Официальный каталог выставки',
                //     link: '/files/RUBAE_catalog.pdf',
                // },
                // {
                //     title: 'Новости и пресса',
                //     link: 'pages/news',
                // },
                {
                    title: 'Аккредитация СМИ',
                    link: '/files/Форма_аккредитации_прессы.docx',
                },
                {
                    title: 'Визовая поддержка',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Трансфер партнер',
                    link: 'pages/transfer-partner',
                },
                {
                    title: 'Размещение в отеле',
                    link: 'pages/hotel-partner',
                },
                {
                    title: 'Программа мероприятия',
                    link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                },
                // {
                //     title: 'Размещение в отеле',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        // {
        //     title: 'Контакты',
        //     items: [
        //         // {
        //         //     title: 'Организационный комитет',
        //         //     link: 'pages/organizing-commitee',
        //         // },
        //         {
        //             title: 'Генеральный застройщик',
        //             link: 'pages/general-contractor',
        //         },
        //         {
        //             title: 'Генеральный экспедитор',
        //             link: 'pages/freight-forwarder',
        //         },
        //         {
        //             title: 'Кейтеринг партнер',
        //             link: 'pages/catering',
        //         },
        //     ],
        // },
        {
            title: 'Фотогалерея',
            items: [
                { title: '2018', link: 'pages/gallery/2018' },
                { title: '2019', link: 'pages/gallery/2019' },
            ],
        },
        {
            title: 'Архив',
            items: [
                {
                    title: '2018',
                    link: 'https://2018.rubae.ru',
                },
                {
                    title: '2019',
                    link: 'https://2019.rubae.ru',
                },
            ],
        },
    ],

    en: [
        {
            title: 'About',
            items: [
                {
                    title: 'Genaral information',
                    link: 'pages/about',
                },
                {
                    title: 'Official brochure',
                    link: '/files/rubae_presentation_2021.pdf',
                },
                {
                    title: 'Floor plan',
                    // link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition.pdf',
                    // link: 'pages/updating',
                },
                // {
                //     title: 'Static display',
                //     link: 'pages/static',
                // },
                {
                    title: 'Exhibitors list',
                    link: 'pages/exhibitors-list',
                },
                // {
                //     title: 'Programe schedule',
                //     link: 'pages/schedule',
                // },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                // {
                //     title: 'Opening hours',
                //     link: 'pages/opening-hours',
                // },
            ],
        },
        {
            title: 'Exhibitor information',
            items: [
                // {
                //     title: 'Exhibiting costs',
                //     link: 'pages/exhibit-application',
                // },
                {
                    title: 'Floor plan',
                    // link: process.env.PAVILION_EXPOSITION_URL,
                    link: '/files/pavilion_exposition.pdf',
                    // link: 'pages/updating',
                },
                {
                    title: 'Personal account',
                    link: 'https://lk.rubae.ru',
                },
                //{
                //     title: 'Exhibit application',
                //     link: '/files/exhibit-application-en.pdf',
                //},
                {
                    title: 'First time exhibitor application',
                    link: '/files/First Time 2021 eng.pdf',
                },
                // {
                //     title: 'Static display application',
                //     link: '/files/static-application-en.pdf',
                // },
                {
                    title: 'Exhibitor manual',
                    link: '/files/exhibitor-manual-en.pdf',
                },
                {
                    title: 'Additional equipment',
                    link: '/files/Additional equipment eng 2021.pdf',
                },
                {
                    title: 'Marketing opportunities',
                    link: '/files/RUBAE_2021_eng.pdf',
                },
                {
                    title: 'Broker Project',
                    link: 'pages/broker-project',
                },
                {
                    title: 'Conference program',
                    link: 'pages/conference-program',
                },
                {
                    title: 'Show Daily newspapper',
                    link: '/files/ShowDaily.pdf',
                },
                {
                    title: 'Visa support',
                    link: 'pages/visa-support',
                },
                // {
                //     title: 'Aircraft cleaning service',
                //     link: 'pages/aircraft-cleaning',
                // },
                {
                    title: 'Transfer partner',
                    link: 'pages/transfer-partner',
                },
                {
                    title: 'Agenda',
                    link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                },
                {
                    title: 'Hotel accommodation',
                    link: 'pages/hotel-partner',
                },
            ],
        },
        {
            title: 'Attendee',
            items: [
                // {
                //     title: 'Registration',
                //     link: 'pages/registration/',
                // },
                // {
                //     title: 'Buy a ticket',
                //     //    link: 'pages/ticket',
                //     //link: 'pages/registration/',
                //     link: 'https://rubae21.ruwidgets.ru/en/',
                // },
                {
                    title: 'Opening hours',
                    link: 'pages/opening-hours',
                },
                {
                    title: 'Venue location',
                    link: 'pages/location',
                },
                // {
                //     title: 'Official Exhibitor catalogue',
                //     link: '/files/RUBAE_catalog.pdf',
                // },
                // {
                //     title: 'News and Press',
                //     link: 'pages/news',
                // },
                // {
                //     title: 'Media accreditation',
                //     link: 'pages/accreditation',
                // },
                {
                    title: 'Visa support',
                    link: 'pages/visa-support',
                },
                {
                    title: 'Transfer partner',
                    link: 'pages/transfer-partner',
                },
                {
                    title: 'Agenda',
                    link: '/files/RUBAE2021 AGENDA_RUS_ENG.pdf',
                },
                {
                    title: 'Hotel accommodation',
                    link: 'pages/hotel-partner',
                },
                // {
                //     title: 'Hotel accommodation',
                //     link:
                //         'http://eventsathilton.com/show/5b3cb1b81eccc8058488ee9b',
                // },
            ],
        },
        // {
        //     title: 'Contacts',
        //     items: [
        //         // {
        //         //     title: 'Organizing Committee',
        //         //     link: 'pages/organizing-commitee',
        //         // },
        //         {
        //             title: 'General Contractor',
        //             link: 'pages/general-contractor',
        //         },
        //         {
        //             title: 'Official freight forwarder',
        //             link: 'pages/freight-forwarder',
        //         },
        //         {
        //             title: 'Catering partner',
        //             link: 'pages/catering',
        //         },
        //     ],
        // },
        {
            title: 'Photo gallery',
            items: [
                { title: '2018', link: 'pages/gallery/2018' },
                { title: '2019', link: 'pages/gallery/2019' },
            ],
        },
        {
            title: 'Archive',
            items: [
                {
                    title: '2018',
                    link: 'https://2018.rubae.ru',
                },
                {
                    title: '2019',
                    link: 'https://2019.rubae.ru',
                },
            ],
        },
    ],
};



// WEBPACK FOOTER //
// ./src/data/navigation.js